import { render } from "./DefaultLayout.vue?vue&type=template&id=3a5522c6"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=3a5522c6&lang=css"

import exportComponent from "../../../../../Users/cole/Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__